import React, { Component } from 'react'

import Page from 'components/Page'
import PageHeader from 'components/Page/PageHeader'
import { Crumbs, Crumb } from 'components/BreadCrumbs'
import Flow from 'features/Flows/Flow'

import cn from 'classnames'
import sLay from 'styles/modules/layout.scss'

export default class FlowPage extends Component {
  componentWillMount() {
    const {
      getFlow,
      getPricing,
      getNumbers,
      routeParams: { flowId },
    } = this.props
    getFlow(flowId)
    getNumbers()
    getPricing()
  }
  render() {
    const {
      flow,
      routeParams: { flowId },
    } = this.props
    return (
      <Page layout={{ header: 'app' }} title="Flow" className={cn(sLay['layout-column'])}>
        <PageHeader>
          <Crumbs title="Flows">
            <Crumb parent to="/dashboard/flows">
              Flows
            </Crumb>
            <Crumb active to={`/dashboard/flows/${flowId}`}>
              {flow && flow.name}
            </Crumb>
            <Crumb to={`/dashboard/flows/${flowId}/logs`}>Logs</Crumb>
          </Crumbs>
        </PageHeader>
        {flow && <Flow flow={flow} />}
      </Page>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Flow/Flow.jsx